module.exports = __webpack_public_path__ + "static/media/29470009-QGf1wSgs.29836fbf.JPG";